import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";

import AgendamentoTipoService from '../../service/AgendamentoTipoService';
import AuthorizationService from '../../service/AuthorizationService';

const agendamentoTipoService = new AgendamentoTipoService();

const ListarTipoAgendamento = () => {
    const [tipoAgendamento, setTipoAgendamento] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [activeDialog, setActiveDialog] = useState(false);
    const [toDelete, setToDelete] = useState(null);
    const [toActive, setToActive] = useState(null);

    const iss = localStorage.getItem('iss');

    const initFilters1 = () => {
        setFilters1({
            'nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'descricao': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    const initTipoAgendamento = useCallback(async () => {
        setLoading1(true);

        try {
            const data = await agendamentoTipoService.listTipoAgendamentos(iss);
            setTipoAgendamento(data.data.rows);
        } catch (error) {
            console.error("Erro ao carregar tipo agendamento:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar tipo agendamento' });
        } finally {
            setLoading1(false);
        }
    }, [iss]);

    useEffect(() => {
        initFilters1();
        initTipoAgendamento();
    }, [initTipoAgendamento]);


    const irParaCadastro = () => {
        if (AuthorizationService.hasPermission('postTipoAgendamento'))
            history.push('/agendamento/tipo/cadastrar');
    }

    const abreModalDeletar = (tipo) => {
        setToDelete(tipo);
        setDeleteDialog(true);
    }

    const abreModalAtivar = (usuario) => {
        setToActive(usuario);
        setActiveDialog(true);
    }

    const handleDeleteTipo = () => {
        if (AuthorizationService.hasPermission('deleteTipoAgendamento')) {
            setLoading1(true)
            agendamentoTipoService.deleteTipoAgendamento(iss, toDelete.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Tipo excluído com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initTipoAgendamento();
            });
        }
    }

    const handleActiveUsuario = () => {
        if (AuthorizationService.hasPermission('activeUser')) {
            setLoading1(true)
            let status = toActive.ativo ? 0 : 1;
            agendamentoTipoService.activeUser(iss, toActive.id, status).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: `Usuario ${status ? 'ativado' : 'desativado'} com sucesso` });
                setLoading1(false);
                hideModalActive();
                initTipoAgendamento();
            });
        }
    }

    const editar = (tipoParaEditar) => {
        if (AuthorizationService.hasPermission('getTipoAgendamento'))
            history.push('/agendamento/tipo/editar/' + tipoParaEditar.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setToDelete(null);
    }

    const hideModalActive = () => {
        setActiveDialog(false);
        setToActive(null);
    }

    const statusBody = (rowData) => {
        return AuthorizationService.hasPermission('activeUser') ? <Button icon={rowData.ativo ? 'pi pi-check' : 'pi pi-times'} onClick={() => { abreModalAtivar(rowData) }} className="p-button-rounded  mr-2 mb-2" style={{ backgroundColor: rowData.ativo ? 'green' : 'red', color: 'black' }} /> : <></>
        // return <i className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.ativo, 'text-pink-500 pi-times-circle': !rowData.ativo })}></i>;
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {AuthorizationService.hasPermission('deleteTipoAgendamento') ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {AuthorizationService.hasPermission('getTipoAgendamento') ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const deleteFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTipo} />
        </>
    );

    const activeDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalActive} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleActiveUsuario} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {AuthorizationService.hasPermission('postTipoAgendamento') ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Serviços</h5>
                    <DataTable value={tipoAgendamento} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma agendamento cadastrado.">
                        <Column sortable field="companies.name" header="Empresa" filter filterPlaceholder="Procurar por empresa" style={{ minWidth: '12rem' }} />
                        <Column sortable field="nome" header="Tipo" filter filterPlaceholder="Procurar por tipo" style={{ minWidth: '12rem' }} />
                        <Column sortable field="descricao" header="Descrição" filter filterPlaceholder="Procurar por descrição" style={{ minWidth: '12rem' }} />
                        <Column sortable field="valor" header="Valor" filter filterPlaceholder="Procurar por descrição" style={{ minWidth: '12rem' }} />
                        <Column sortable field="duracao_padrao" header="Duração do atendimento" style={{ minWidth: '12rem' }} />
                        <Column sortable field="status" body={statusBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir o tipo de agendamento selecionado?</span>
                </div>
            </Dialog>

            <Dialog visible={activeDialog} style={{ width: '450px' }} header="Ativar/Desativar" modal footer={activeDialogFooter} onHide={hideModalActive}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja ativar/destivar o usuário selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarTipoAgendamento, comparisonFn);
